module.exports = __webpack_public_path__ + "static/media/close.24228f57.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/close.svg
// module id = 267
// module chunks = 0